import type { FavoriteData } from 'owa-favorites-types';
import favoritesStore from '../../store/store';
import getSecondaryKey from '../../utils/getSecondaryKey';

export default function setUnusedFavoriteDataInStore(favoriteData: FavoriteData): void {
    const { unusedFavoriteKeyMap, unusedFavorites } = favoritesStore();

    favoriteData.treeType = 'favorites';
    unusedFavorites.set(favoriteData.favoriteId, favoriteData);

    const secondaryKey = getSecondaryKey(favoriteData);
    if (secondaryKey) {
        unusedFavoriteKeyMap.set(secondaryKey, favoriteData.favoriteId);
    }
}
